import React from "react";
import { Box, Grid, InputLabel, Typography } from "@mui/material";

import CustomSelectV2 from "./CustomSelectV2";
import SecondaryButton from "./SecondaryButton";

const ExportDialog = () => {
  return (
    <Grid
      container
      sx={{ width: 400, height: 250, padding: "1rem" }}
      alignItems="center"
    >
      <Grid item xs={12} sx={{ height: "15%" }}>
        <Typography
          sx={{
            fontSize: 18,
            fontWeight: 500,
            letterSpacing: -0.64,
            color: "var(--secondary)",
          }}
        >
          Export
        </Typography>
      </Grid>
      <Grid item xs={12} sx={{ height: "70%" }}>
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
            paddingTop: "1rem",
            gap: 2,
          }}
        >
          <InputLabel htmlFor="select-export-format">Select format</InputLabel>
          <CustomSelectV2
            id="select-export-format"
            label={null}
            value={{ id: "pdf", label: "Export as .PDF", value: "pdf" }}
            options={[
              { id: "pdf", label: "Export as .PDF", value: "pdf" },
              { id: "csv", label: "Export as .CSV", value: "csv" },
              { id: "docx", label: "Export as .DOCX", value: "docx" },
            ]}
            width="80%"
          />
        </Box>
      </Grid>
      <Grid item xs={12} sx={{ height: "15%" }}>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <SecondaryButton>Export</SecondaryButton>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ExportDialog;
